import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs4";
import Loading from "../../Components/Loading/Loading";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import ReactPaginate from "react-paginate";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import SupportTicketView from "../../Components/SupporTicketView/SupportTicketView";
import CustomToast from "../../Components/CustomToast/CustomToast";

function UsersUi({
  columns,
  data,
  tableQaury,
  onPageChange,
  totalRecords,
  loading,
  deleteAdminFn,
  setTableQaury,
  selectData,
  setFiltersId,
  setSelectData,
  filtersId,
  removeFilter,
  decodedToken,
  toast,
  handleAddAuditor
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <ContentHeader
              title={"Auditors"}
              buttonName={"Add Auditor"}
              buttonBoolean={false}
              pageName={""}
              linkPath={""}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        <div className="d-flex ">
                          <div className={`d-md-flex ${( decodedToken?.role == 3 || decodedToken?.role == 4) ? "mr-3" :"mr-0"}  mb-3 justify-content-between align-items-center dt-layout-start `}>
                            {( decodedToken?.role == 3 || decodedToken?.role == 4) ? (
                              <>
                                <RrbDropdown
                                  selectData={selectData}
                                  setFiltersId={setFiltersId}
                                  setSelectData={setSelectData}
                                  filtersId={filtersId}
                                  removeFilter={removeFilter}
                                  decodedToken={decodedToken}
                                  showFilter={{
                                    rrb: true,
                                  }}
                                />
                              </>
                            ) : (
                          //     <>
                          //         <Search
                          //   setTableQaury={setTableQaury}
                          //   tableQaury={tableQaury}
                          //   placeHolder={"Search By Here"}
                          //   buttonName={""}
                          //   buttonBoolean={false}
                          //   linkPath={""}
                          // />
                          //     </>
                          null
                            )}
                          </div>
                          {/* <div className="d-md-flex mb-0 ml-3 justify-content-between align-items-center dt-layout-end "> */}
                           
                          
                              <Search
                            
                            setTableQaury={setTableQaury}
                            tableQaury={tableQaury}
                            placeHolder={"Search By Here"}
                            buttonName={""}
                            buttonBoolean={false}
                            linkPath={""}
                          />

                            <div
                              className="d-flex justify-content-end align-items-end mb-3"
                              style={{ minWidth: "135px" }}
                            >
                              <button
                                className="blue-btn"
                                onClick={() => {
                                  handleAddAuditor()
                                }}
                              >
                                Add Auditor
                              </button>
                            </div>
                        
                          {/* </div> */}
                        </div>
                        {/* <Search setTableQaury={setTableQaury} tableQaury={tableQaury} placeHolder={"Search By Name"}/> */}
                        <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAdminFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default UsersUi;
